import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/notifications')({
  component: lazyRouteComponent(() => import('./-notifications.lazy'), 'default'),
});
